
import { getToken, setToken, removeToken,
    getUsername, setUsername, removeUsername,
    getLadyId, setLadyId, removeLadyId } from '@/utils/auth';
import { login, logout } from '@/api/Login';
import * as types from '../mutation-types';
import VueCookies from 'vue-cookies'


/* eslint-disable */
// initial state
const state = {
    username: getUsername(), // 昵称
    token: getToken(), // 登录token
    ladyId: getLadyId(),//配送员id
};

// getters
const getters = {
    username: state => state.username,
    token: state => state.token,
    ladyId: state => state.ladyId
};

// mutations
const mutations = {
    [types.RECEIVE_ADMIN_NAME](state, userName) {
        state.username = userName;
        if (userName === '') {
            removeUsername();
        } else {
            setUsername(userName);
        }
    },
    [types.RECEIVE_ADMIN_TOKEN](state, token) {
        state.token = token;
        if (token === '') {
            removeToken();
        } else {
            setToken(token);
            VueCookies.set('ADMIN-TOKEN', token);
        }
    },
    [types.RECEIVE_LADY_ID](state, ladyId) {
        state.ladyId = ladyId;
        if (ladyId === '') {
            removeLadyId();
        } else {
            setLadyId(ladyId);
        }
    },
};

// actions
const actions = {
    // 用户登录
    Login({ commit }, userInfo) {
        const username = userInfo.username;
        // const password = sha256(userInfo.password);
        const password = userInfo.password;
        return new Promise((resolve, reject) => {
            login(username, password)
                .then((response) => {
                    if (response.code === types.API_CODE.OK) {
                        const data = response.data;
                        commit(types.RECEIVE_ADMIN_NAME, data.username);
                        commit(types.RECEIVE_ADMIN_TOKEN, data.token);
                        commit(types.RECEIVE_LADY_ID, data.ladyId);
                        localStorage.setItem(types.RECEIVE_RULE_READ, data.readed);
                        localStorage.setItem(types.RECEIVE_PASS_WORD, data.updatePwd);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    // 登出
    Logout({ commit }) {
        return new Promise((resolve) => {
            logout(getters.token);
            commit(types.RECEIVE_ADMIN_TOKEN, '');
            commit(types.RECEIVE_ADMIN_NAME, '');
            commit(types.RECEIVE_LADY_ID, '');
            localStorage.getItem(types.RECEIVE_RULE_READ, '');
            localStorage.getItem(types.RECEIVE_PASS_WORD, '');
            resolve();
        });
    },
    // 前端 登出
    FedLogout({ commit }) {
        return new Promise((resolve) => {
            commit(types.RECEIVE_ADMIN_TOKEN, '');
            commit(types.RECEIVE_ADMIN_NAME, '');
            commit(types.RECEIVE_LADY_ID, '');
            localStorage.getItem(types.RECEIVE_RULE_READ, '');
            localStorage.getItem(types.RECEIVE_PASS_WORD, '');
            resolve();
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
